import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'seo-logged_out_brand_c2_tab-click';
/**
 * Tracks any click on a C2 tab. These C2s correspond to the products that a brand has. These tabs show on the logged-out brand page.
 */
export function trackSeoLoggedOutBrandC2TabClick(brandToken, Category_Key) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { brandToken, Category_Key },
    });
}
